/* eslint-disable react/forbid-prop-types */
import React from 'react';
import moment from 'moment';
import { Row, Col, Card, CardText, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';
import AdvCampgainsChart from './AdvCampgainsChart';

const AdvCampgains = ({ dir, data, viewReportButton, title }) => {
    const dataToPlot = [];

    const dataByDate = {};

    data.forEach((item) => {
        if (dataByDate[moment(item.date).format('MM-DD-YYYY')]) {
            dataByDate[moment(item.date).format('MM-DD-YYYY')].push(item)
        } else {
            dataByDate[moment(item.date).format('MM-DD-YYYY')] = [item]
        }
    });

    Object.keys(dataByDate).forEach((dataDay) => {
        let sales = 0;
        let cost = 0;

        const dayData = dataByDate[dataDay];

        dayData.forEach((item) => {
            sales += Number(item.sales);
            cost += Number(item.cost);
        })

        dataToPlot.push({
            title: dataDay,
            Cost: cost,
            Sales: sales,
            ACOS: Number((cost / (sales || 1)) * 100).toFixed(2)
        })
    });

    return (
        <Col xs="12">
            <Card className="pb-3 show-categ-daily-sales">
                <div className="card__title row " style={{ position: 'relative' }}>
                    {title}
                    <div id='dvChartView'>
                    {viewReportButton?.()}</div>
                </div>

                {data?.length ? (
                    <AdvCampgainsChart
                        dataToPlot={dataToPlot}
                        height={400}
                        showTitle={false}
                        dir={dir}
                    />

                ) : 'No data to display'}
            </Card>
        </Col>

    )
}

AdvCampgains.propTypes = {
    dir: PropTypes.string.isRequired,
    data: PropTypes.arrayOf({}).isRequired,
    title: PropTypes.string,
    viewReportButton: PropTypes.func.isRequired,
};

AdvCampgains.defaultProps = {
    title: 'New/ Return Customer',
}

export default AdvCampgains;
